import React, { useContext, useId, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiGallection } from '@wix/da-papi-types';
import GalleryMultiselect from '../../../common/GalleryMultiselect';
import { SubmitFormContext } from '../../../context';
import { InitResponse } from '../../../redux/types';

interface Props {
  className?: string;
}

const GalleryFolderSelect: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const id = useId();
  const initResponse = useContext(SubmitFormContext)?.initResponse;
  const { galleries: allGalleries = [], inGalleries = [] } =
    initResponse as InitResponse;

  const items = useMemo(() => {
    const isSelected = (gallery: PapiGallection) => {
      if (inGalleries.length > 0) {
        return inGalleries.some(g => g.folderId === gallery.folderId);
      }
      return false;
    };

    return allGalleries.map(gallery => ({
      gallery,
      value: `${gallery.folderId}`,
      selected: isSelected(gallery),
    }));
  }, [allGalleries, inGalleries]);

  const handleChange = () => {};

  return (
    <GalleryMultiselect
      className={className}
      id={id}
      label={t('originals.deviationSubmit.form.visibility.gallery.label')}
      placeholder={t(
        'originals.deviationSubmit.form.visibility.gallery.placeholder'
      )}
      items={items}
      onChange={handleChange}
    />
  );
};
GalleryFolderSelect.displayName = 'GalleryFolderSelect';

export default GalleryFolderSelect;
